import { CoverageRejection } from './CoverageRejection';

export default CoverageRejection;
